exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.grad[data-v-5a26063c] {\r\n  background-image: linear-gradient(45deg, #3c8ce7 50%, #00eaff 90%);\n}\r\n", ""]);

// exports
